import { render } from "./PopupBox.vue?vue&type=template&id=61d16903&scoped=true"
import script from "./PopupBox.vue?vue&type=script&lang=js"
export * from "./PopupBox.vue?vue&type=script&lang=js"

import "./PopupBox.vue?vue&type=style&index=0&id=61d16903&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d16903"]])

export default __exports__